import styled, { css } from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div<{ $setCenter?: boolean }>`
  display: flex;
  gap: 4px;
  justify-content: center;
  margin: 0 0 ${Spacing.M};

  ${({ $setCenter }) =>
    $setCenter &&
    css`
      align-items: center;
    `}
`

export const IconContainer = styled.div``
export const AutoApplyInfoText = styled.p`
  ${Typography.Caption};
  ${FontWeights.Regular}
  color: ${Colors.Neutral80};
`

export const AutoApplyInfoLink = styled.span`
  ${Typography.Caption};
  ${FontWeights.Regular}
  color: ${Colors.Blue50};
  cursor: pointer;
`
